@if (selectedEntity) {
  <section class="template-section" @transitionHeight>
    @if (!(loading$ | async)) {
      <h3 class="basic-flex-container"><mat-icon fontSet="material-icons-outlined">inventory_2</mat-icon>Destination</h3>
      <form [formGroup]="configuration" class="basic-flex-container with-border">
        <ng-container formArrayName="documentDestination">
          @for (item of documentDestinationOptions; track item; let i = $index) {
            <div class="destination-container">
              <div [formGroupName]="i" class="basic-flex-container">
                @if (documentDestinationOptions.length === 1) {
                  <p class="basic-flex-container no-mar-b">
                    <i class="{{ iconService.getIcon(item.entityType) | lowercase }}"></i>
                    From a {{ item.label }}
                  </p>
                }
                @if (documentDestinationOptions.length > 1) {
                  <p class="basic-flex-container no-mar-b">
                    <i class="{{ iconService.getIcon(item.entityType) | lowercase }}"></i>
                    From a {{ item.label }}
                  </p>
                }
                <mat-select multiple placeholder="Select entities" formControlName="paths">
                  <mat-select-trigger>
                    @switch (getOptionPaths(i).length) {
                      @case (0) {
                        Select entities...
                      }
                      @case (1) {
                        {{ pathDisplay(getOptionPaths(i)[0]) }}
                      }
                      @case (2) {
                        {{ pathDisplay(getOptionPaths(i)[0]) }} and {{ pathDisplay(getOptionPaths(i)[1]) }}
                      }
                      @default {
                        {{ pathDisplay(getOptionPaths(i)[0]) }} (+{{ getOptionPaths(i).length - 1 }} more)
                      }
                    }
                  </mat-select-trigger>
                  @for (destination of item.options; track destination.path) {
                    <mat-option
                      [value]="destination.path"
                      [matTooltip]="destination.tooltip ?? destination.path"
                      matTooltipShowDelay="500"
                      matTooltipClass="tooltip-no-truncate"
                      matTooltipPosition="after"
                    >
                      {{ destination.label }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </div>
          }
        </ng-container>
      </form>
    } @else {
      <span class="loading-spinner spinner-border spinner-border-sm"></span>
    }
  </section>
}
